// extracted by mini-css-extract-plugin
export default {"Button":"FavoriteButton_Button__6zgEz","Active":"FavoriteButton_Active__G6Dzm","Placeholder":"FavoriteButton_Placeholder__0OYGi"};